/**
 * 布局
 * @param layout?:     每行展示几列 默认为3 需能被24的整除
 * @param floatChild?: 浮动元素，当第一行元素数量少于layout时与元素保持一行，超出则溢出到下一行
 * @param gutter?:     行内Col元素的间距
 * */
import { __rest } from "tslib";
import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { getDataType } from '@/shared/functions';
class RowCol extends Component {
    getDealChild() {
        const { children, layout } = this.props;
        if (getDataType(children) !== 'Array') {
            return [[children]];
        }
        const effectChildren = children.filter((item) => item);
        const dealList = [];
        for (let i = 0; i < effectChildren.length; i += layout) {
            dealList.push(effectChildren.slice(i, i + layout));
        }
        return dealList;
    }
    dealRowCol() {
        const _a = this.props, { layout, floatChild, gutter, className } = _a, restProps = __rest(_a, ["layout", "floatChild", "gutter", "className"]);
        const childrenList = this.getDealChild();
        const resultList = childrenList.map((child, index) => {
            return (<Row key={`row_${index}`} gutter={gutter} {...restProps}>
          {child.map((v, i) => {
                return (<Col span={24 / layout} key={`col_${index}_${i}`}>
                  {v}
                </Col>);
            })}
          {index === 0
                &&
                    child.length < (layout)
                && (<React.Fragment>
                <Col span={24 - (24 / layout) * (child.length + 1)}/>
                {floatChild}
              </React.Fragment>)}
        </Row>);
        });
        childrenList[0].length > (layout - 1) && resultList.push(<Row key={`row_${resultList.length + 1}`}>
        <Col span={24 - (24 / layout)}/>
        {floatChild}
      </Row>);
        return resultList;
    }
    render() {
        return (<div className={this.props.className || ''}>
        {this.dealRowCol()}
      </div>);
    }
}
RowCol.defaultProps = {
    layout: 3,
    floatChild: null,
    gutter: 0,
};
export default RowCol;
